module.exports = __webpack_public_path__ + "static/media/Memories.4bb95224.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Memories.otf
// module id = 2232
// module chunks = 50